import {ReferralSourceService} from 'services/referralSourceService';
import {createEntityThunks} from 'utils/createEntityThunks';
import {ReferralSource} from 'types/referralSource';

const referralSourceFactory = (data: any) => new ReferralSource(data);

export const ReferralSourceThunks = createEntityThunks<ReferralSource>(
  'referralSource',
  ReferralSourceService,
  {},
  referralSourceFactory,
);
